import React from "react";

const Assignment = () => {
  return (
    <div>
      <h1>Assignment Component</h1>
      <p>Content for Assignment goes here...</p>
    </div>
  );
};

export default Assignment;
